import { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ScrollFadeIn = ({ children }) => {
  const fadeRef = useRef(null);

  useEffect(() => {
    if (!fadeRef.current) return;

    const elements = fadeRef.current.children; // `children` のすべての要素を取得

    gsap.utils.toArray(elements).forEach((el, index) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 50 }, // 初期状態（透明＆50px下）
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: el, // 各子要素がトリガー
            start: "top 80%", // 各要素の `top 80%` で発火
            toggleActions: "play none none reset",
            once: false,
          },
        }
      );
    });

    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  }, []);

  return <div className="skill-detail" ref={fadeRef}>{children}</div>;
};

export default ScrollFadeIn;
